import React, { useMemo } from 'react'
import { ReactFCC } from '@/types/react'
import { useDerivedAriaLabel } from '@/utils/reactUtils/reactChildrenUtils'

export interface ExternalLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  target?: string
  trusted?: boolean
}

export const TRUSTED_DOMAINS = ['angel.com', 'angelstudios.com']

const isTrustedDomain = (href: string): boolean => {
  if (!href) return false
  return href.startsWith('/') || TRUSTED_DOMAINS.some((domain) => href.indexOf(domain) > -1)
}

export const ExternalLink: ReactFCC<ExternalLinkProps> = (props) => {
  const { href, trusted, target, children, ...rest } = props
  const isTrusted = useMemo(() => trusted || isTrustedDomain(href), [href, trusted])
  const ariaLabel = useDerivedAriaLabel(props)

  if (!href) return null

  const isAnApiRoute = href.startsWith('/api')
  const targ = target ? target : isAnApiRoute ? '_self' : '_blank'

  return (
    <a
      {...rest}
      href={href}
      target={targ}
      rel={`${isTrusted ? '' : 'external noopener noreferrer'}`}
      aria-label={ariaLabel}
    >
      {children}
    </a>
  )
}
